import L from 'leaflet'
import type { Map } from 'leaflet'

interface GridPoint {
  lat: number
  lng: number
}

export class GridSystem {
  private map: Map
  private gridWidth = 0.1
  private gridHeight = 0.1

  constructor(map: Map, gridWidth = 0.5, gridHeight = 0.5) {
    this.map = map
    this.gridWidth = gridWidth
    this.gridHeight = gridHeight
    this.map.on('zoomend', this.handleZoomChange.bind(this))
  }
  private handleZoomChange() {
    // 根据当前缩放级别动态计算网格宽度和高度
    this.gridWidth = this.calculateGridWidthBasedOnZoom()
    this.gridHeight = this.calculateGridHeightBasedOnZoom()
    console.log(this.gridWidth, this.gridHeight)
    // // 重新构建网格存储结构
    // this.grid = this.initializeGrid()
  }
  private calculateGridWidthBasedOnZoom(): number {
    const mapContainer = this.map.getContainer()
    const containerWidth = mapContainer.clientWidth

    const desiredPixelGridsPerRow = 60 // 希望每行显示的像素网格数（可根据实际需求调整）
    const pixelWidthPerGrid = containerWidth / desiredPixelGridsPerRow

    // 使用地图的latLngToContainerPoint方法将像素宽度转换为地理距离
    const swCorner = this.map.containerPointToLatLng(L.point(0, 0))
    const neCorner = this.map.containerPointToLatLng(L.point(containerWidth, 0))
    const latLngWidth = neCorner.distanceTo(swCorner)

    return (pixelWidthPerGrid * latLngWidth) / containerWidth / 10000
  }

  private calculateGridHeightBasedOnZoom(): number {
    return this.calculateGridWidthBasedOnZoom() // 假设网格宽高比为1:1
  }

  /**
   * 计算给定点所属网格的索引。
   * @param point - 坐标点
   */
  getGridIndex(point: L.LatLng): {
    gridLngIndex: number
    gridLatIndex: number
  } {
    const { lat, lng } = point
    const gridLngIndex = Math.floor(lng / this.gridWidth)
    const gridLatIndex = Math.floor(lat / this.gridHeight)
    return { gridLngIndex, gridLatIndex }
  }

  /**
   * 构建网格存储结构
   * @param bounds - 数据分布的地理边界
   */
  initializeGrid(): GridPoint[][] {
    const { lat: west, lng: south } = this.map.getBounds().getSouthWest()
    const { lat: east, lng: north } = this.map.getBounds().getNorthEast()
    const numLngCells = Math.ceil((east - west) / this.gridWidth)
    const numLatCells = Math.ceil((north - south) / this.gridHeight)

    return Array.from({ length: numLatCells }, () =>
      // eslint-disable-next-line unicorn/no-new-array
      new Array(numLngCells).fill(null as GridPoint | null)
    )
  }

  /**
   * 将坐标点集合进行网格化筛选，存储至指定网格
   * @param points - 原始坐标点集合
   */
  filterAndStorePoints(points: L.LatLng[]): L.LatLng[] {
    this.handleZoomChange()
    const grid: GridPoint[][] = this.initializeGrid()
    for (const point of points) {
      const { gridLngIndex, gridLatIndex } = this.getGridIndex(point)

      if (!grid[gridLatIndex][gridLngIndex]) {
        grid[gridLatIndex][gridLngIndex] = { lat: point.lat, lng: point.lng }
      } else {
        // 非空网格，根据选择策略决定是否替换现有点
        // 这里仅作为示例，未实现具体策略
        // ...
      }
    }
    return this.getFilteredPoints(grid)
  }

  getFilteredPoints(grid: GridPoint[][]): L.LatLng[] {
    return (
      grid
        // @ts-ignore: TS2550 TS7006
        .flatMap((row) =>
          // @ts-ignore: TS7006
          row.map((cell) => {
            if (cell) {
              return L.latLng(cell.lat, cell.lng)
            }
            return null
          })
        )
        .filter(Boolean) as L.LatLng[]
    )
  }
}

// 使用示例
// const map = L.map('map').setView([51.505, -0.09], 13);
// const gridSystem = new GridSystem(map);
// const originalPoints: L.LatLng[] = [...]; // 原始坐标点集合
// const grid = gridSystem.filterAndStorePoints(originalPoints);
